require("!!/home/vsts/work/1/s/node_modules/script-loader/addScript.js")(require("!!/home/vsts/work/1/s/node_modules/raw-loader/index.js!/home/vsts/work/1/s/node_modules/jspdf/dist/jspdf.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/jspdf/dist/jspdf.min.js
// module id = 677
// module chunks = 3